//const BACKEND_URI = "http://localhost:5000"; // Uncomment this line for local development
const BACKEND_URI = "";
import { ChatAppResponse, ChatAppResponseOrError, ChatAppRequest, Config } from "./models";
import { useLogin } from "../authConfig";
import axios from "axios";
function getHeaders(accessToken?: string, lang?: string): Record<string, string> {
    const headers: Record<string, string> = {
        "Content-Type": "application/json",
    };
    if (useLogin && accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    if (lang) {
        headers["Accept-Language"] = lang;
    }
    return headers;
}

async function retryFetch(
    input: RequestInfo,
    init: RequestInit,
    retries = 3,
    backoff = 300
): Promise<Response> {
    try {
        const res = await fetch(input, init);
        if (res.status === 502 && retries > 0) {
            await new Promise(r => setTimeout(r, backoff));
            return retryFetch(input, init, retries - 1, backoff * 2);
        }
        return res;
    } catch (err) {
        if (retries > 0) {
            await new Promise(r => setTimeout(r, backoff));
            return retryFetch(input, init, retries - 1, backoff * 2);
        }
        throw err;
    }
}


export async function askApi(request: ChatAppRequest, idToken: string | undefined): Promise<ChatAppResponse> {
    const response = await fetch(`${BACKEND_URI}/ask`, {
        method: "POST",
        headers: getHeaders(idToken),
        body: JSON.stringify(request)
    });

    const parsedResponse: ChatAppResponseOrError = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error(parsedResponse.error || "Unknown error");
    }

    return parsedResponse as ChatAppResponse;
}

export async function configApi(idToken: string | undefined): Promise<Config> {
    const response = await fetch(`${BACKEND_URI}/config`, {
        method: "GET",
        headers: getHeaders(idToken)
    });

    return (await response.json()) as Config;
}

export async function chatApi(
    request: ChatAppRequest,
    idToken?: string,
    lang?: string
): Promise<Response> {
    const url = `${BACKEND_URI}/chat`;
    const init: RequestInit = {
        method: "POST",
        credentials: "include",
        headers: getHeaders(idToken, lang),
        body: JSON.stringify(request),
    };
    return retryFetch(url, init);
}

export function getCitationFilePath(citation: string): string {
    return `${BACKEND_URI}/content/${citation}`;
}


export async function getTranslations(
    lang: string
): Promise<{ [key: string]: string }> {
    const response = await fetch(
        `${BACKEND_URI}/translations?lang=${encodeURIComponent(lang)}`,
        {
            method: "GET"
        }
    );

    if (!response.ok) {
        throw new Error(`Failed to load translations for lang=${lang}`);
    }

    return (await response.json()) as { [key: string]: string };
}